<template>
    <AppModal :title="$t('labels.copy_integration_modal')" ref="modal" @on-hide="hide" size="sm">
        <div class="modal-body">
            <div class="row flex-wrap" :style="{ gap: '1.25rem' }">
                <div class="col-lg-12">
                    <FormGroup :label="$t('labels.name')">
                        <Input v-model="name" />
                    </FormGroup>
                </div>
                <div class="col-lg-12">
                    <InputGroup>
                        <AppCheckbox v-model="keepProductSourceIds" />
                        <template #append>
                            {{ $t('labels.copy_integration_keep_product_source_ids') }}
                        </template>
                    </InputGroup>
                </div>
                <div class="col-lg-12">
                    <InputGroup>
                        <AppCheckbox :model-value="keepCategoryAttributes" @update:model-value="keepCategoryAttributes = $event, keepProductAttributes = false" />
                        <template #append>
                            {{ $t('labels.copy_integration_keep_category_attributes') }}
                        </template>
                    </InputGroup>
                </div>
                <div class="col-lg-12">
                    <InputGroup>
                        <AppCheckbox v-model="keepProductAttributes" :disabled="!keepCategoryAttributes"/>
                        <template #append>
                            {{ $t('labels.copy_integration_keep_product_attributes') }}
                        </template>
                    </InputGroup>
                </div>
            </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
            <AppButton color="indigo" :disabled="pendingResponse || !name" @click="copyIntegration">
                {{ $t('buttons.copy') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../../components/new/form/Input.vue';
import InputGroup from '../../../../../../components/new/form/InputGroup.vue';
import AppCheckbox from '../../../../../../components/new/form/checkbox/AppCheckbox.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../../services/HttpClient';
import MessageNotificator from '../../../../../../services/MessageNotificator.js';

export default {
    name: "CopyIntegrationModal",
    components: {
        AppModal, FormGroup, Input, InputGroup, AppCheckbox, AppButton
    },
    data() {
        return {
            name: '',
            keepProductSourceIds: false,
            keepCategoryAttributes: false,
            keepProductAttributes: false,
            pendingResponse: false
        }
    },
    methods: {
        show() {
            this.$refs.modal.show()
        },
        hide() {
            this.$refs.modal.hide()
            this.name = '';
            this.keepProductSourceIds = false;
            this.keepCategoryAttributes = false;
            this.keepProductAttributes = false;
            this.pendingResponse = false;
        },
        async copyIntegration() {
            this.pendingResponse = true;

            await httpClient.post(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/copy`, {
                name: this.name,
                keep_product_source_ids: Number(this.keepProductSourceIds),
                keep_category_attributes: Number(this.keepCategoryAttributes),
                keep_product_attributes: Number(this.keepProductAttributes)
            })
            .then((response) => {
                this.hide();
                new MessageNotificator().success(this.$t('alerts.success'))
            })

            this.pendingResponse = false;
        }
    }
}
</script>